<template>
  <GestionUsuarios />
</template>
<script>
import GestionUsuarios from "./components/GestionUsuarios";
export default {
  components: { GestionUsuarios },
  created(){
    if (!this.$store.getters["auth/isLogged"]) {
      this.$router.push({ name: "Login" });
    }
  },
  methods: {
    isLogged() {
      return this.$store.getters["auth/isLogged"]
        ? this.$store.getters["auth/isLogged"]
        : false;
    },
  }
};
</script>